/* =============================================================================
 *  Kreux Matrix — Legal Pages · In-Page EN/DE Language Toggle
 *  Fixed pill toggle for direct-link visitors to /imprint, /privacy, /terms.
 *  Interfaces exclusively with useLang() · reuses established brand vars.
 * ===========================================================================*/

import { useLang } from "@/lib/LangContext";

const LegalLangToggle = () => {
  const { lang, setLang, t } = useLang();

  const btnBase =
    "relative z-10 px-3.5 py-1.5 text-[11px] font-mono tracking-[0.2em] uppercase rounded-full transition-all duration-500 cursor-pointer select-none";
  const btnActive =
    "bg-[var(--il-cyan)] text-[#0A1520] shadow-[0_0_15px_var(--il-cyan)]";
  const btnIdle =
    "text-white/50 hover:text-[var(--il-cyan)]";

  return (
    <div
      role="group"
      aria-label={t("nav.langLabel")}
      data-testid="legal-lang-toggle"
      className="fixed top-6 right-6 z-50 inline-flex items-center gap-1 p-1 rounded-full border border-white/10 bg-white/5 backdrop-blur-3xl shadow-[0_0_40px_-15px_var(--il-cyan)]"
    >
      <button
        type="button"
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
        data-testid="legal-lang-en"
        className={`${btnBase} ${lang === "en" ? btnActive : btnIdle}`}
      >
        {t("nav.langEN")}
      </button>
      <button
        type="button"
        onClick={() => setLang("de")}
        aria-pressed={lang === "de"}
        data-testid="legal-lang-de"
        className={`${btnBase} ${lang === "de" ? btnActive : btnIdle}`}
      >
        {t("nav.langDE")}
      </button>
    </div>
  );
};

export default LegalLangToggle;
